export default "__VITE_ASSET__DR_ziqJ2__"